module.exports = __webpack_public_path__ + "img/top.72eee4ba.png";